import { render, staticRenderFns } from "./QnCenter.vue?vue&type=template&id=1df78d00&scoped=true&"
import script from "./QnCenter.vue?vue&type=script&lang=js&"
export * from "./QnCenter.vue?vue&type=script&lang=js&"
import style0 from "./QnCenter.vue?vue&type=style&index=0&id=1df78d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df78d00",
  null
  
)

export default component.exports